import React from 'react';
import Button from '../../UI/Button';
import { getListingCategoryStyle } from '../../../JSDC/utils/listingCategoryIcon';
import './index.scss';

export interface ITrailCardProps extends React.HTMLProps<HTMLDivElement> {
  title?: string;
  region?: string;
  additionals?: { [k: string]: string };
  link?: string;
  category?: string;
}
const TrailCard: React.FC<Partial<ITrailCardProps>> = ({
  title = '...',
  region = '...',
  link = '',
  additionals = {},
  category = '',
}) => {
  const { icon: iconClass, color: iconColor } = getListingCategoryStyle(category);
  const ReportDateAndTime = additionals['回報日期'] + ' ' + additionals['回報時間'];
  const showPropKey = (key: string, value: string) => {
    if (key === '回報資料照片網址') {
      return <img src={value} alt="info" style={{ maxWidth: '100%', height: 'auto' }} />;
    }

    return value
      .toString()
      .replace(/<br>/g, ';') // 將 <br> 替換為分號
      .split(';')
      .map((item, index) => <span key={index}>{item}</span>);
  };

  const renderAdditionals = () => {
    return Object.keys(additionals).map((key) => {
      if (key === '回報時間') return null;
      if (key === '回報資料照片網址') {
        return (
          <div key={key} className="TrailCard-Root-Info-Item">
            <div className="TrailCard-Root-Info-Item-Splits">
              {showPropKey(key, additionals[key])}
            </div>
          </div>
        );
      } else if (key === '回報日期') {
        return (
          <div key={key} className="TrailCard-Root-Info-Item">
            <span>{'日期時間'}｜ </span>
            <div className="TrailCard-Root-Info-Item-Splits">{ReportDateAndTime}</div>
          </div>
        );
      } else {
        return (
          <div key={key} className="TrailCard-Root-Info-Item">
            <span>{key}｜ </span>
            <div className="TrailCard-Root-Info-Item-Splits">
              {showPropKey(key, additionals[key])}
            </div>
          </div>
        );
      }
    });
  };

  return (
    <div className="TrailCard-Root">
      <div className="TrailCard-Root-Header">
        <div className="TrailCard-Root-Header-Thumb" style={{ background: iconColor }}>
          <i className={`las ${iconClass}`}></i>
        </div>
        <div className="TrailCard-Root-Header-Title">
          <span className="TrailCard-Root-Header-Title-Main">{`${title}`}</span>
          <span className="TrailCard-Root-Header-Title-Sub">{region}</span>
        </div>
      </div>
      <div className="TrailCard-Root-Info">{renderAdditionals()}</div>
      {link && (
        <a href={link} target="_blank">
          <Button className="TrailCard-Root-More">更多資訊</Button>
        </a>
      )}
    </div>
  );
};
TrailCard.displayName = 'TrailCard';
export default TrailCard;
